<template>
    <v-dialog transition="dialog-top-transition" max-width="600">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                width="210px"
                v-if="hasManagerPermission"
                class="py-4"
                dark
                :style="
                    !$vuetify.breakpoint.smAndDown
                        ? 'margin-right: 12px !important'
                        : ''
                "
                small
                outlined
                color="red darken-3 py-4"
                v-bind="attrs"
                v-on="on"
                >Copiar objetivos
                <v-icon right>mdi-file-replace-outline</v-icon>
            </v-btn>
        </template>
        <template v-slot:default="dialog">
            <v-card>
                <v-card-title primary-title class="d-block text-center">
                    <div
                        v-if="$vuetify.breakpoint.xs"
                        class="primary--text text-overline"
                    >
                        Copiar Objetivos
                        <div class="mt-n2 font-weight-light grey--text">
                            {{ currentNameMonthYear }}
                        </div>
                    </div>
                    <div v-else class="font-weight-light primary--text text-h4">
                        Copiar Objetivos
                        <div class="text-h6 font-weight-light grey--text">
                            {{ currentNameMonthYear }}
                        </div>
                    </div>
                </v-card-title>
                <!-- <v-divider class="test"></v-divider> -->
                <v-progress-linear
                    v-if="isLoadingCopyObjetives"
                    color="#4CAF50"
                    class="my-2"
                    height="4"
                    :indeterminate="isLoadingCopyObjetives"
                ></v-progress-linear>
                <v-card-text class="pa-3">
                    <div>
                        <div class="pa-6 text-h6 text-center">
                            <p class="ma-0">
                                Se copiaran los objetivos del mes:
                            </p>
                            <div class="d-flex justify-center">
                                <v-icon class="mr-1"> mdi-calendar </v-icon>
                                <p class="ma-0 red--text">
                                    {{ currentNameMonthYear }}
                                </p>
                            </div>
                            <v-icon>mdi-arrow-down</v-icon>
                            <div class="d-flex justify-center">
                                <v-icon class="mr-1"> mdi-calendar </v-icon>
                                <p class="ma-0 red--text">
                                    {{ nextNameMonthYear }}
                                </p>
                            </div>
                        </div>
                        <div class="mt-2 d-flex justify-end">
                            <v-btn
                                color="success"
                                @click="copyObjetivesNextMonth"
                            >
                                Copiar
                            </v-btn>
                            <v-btn
                                text
                                color="red"
                                @click="dialog.value = false"
                                >Cerrar</v-btn
                            >
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'FormObjetivo',
    data: () => ({}),
    computed: {
        ...mapGetters('login', {
            hasManagerPermission: 'hasManagerPermission',
        }),
        ...mapState('areaPersonal/calculadora', {
            currentDate: (state) => state.date,
            isLoadingCopyObjetives: (state) => state.isLoadingCopyObjetives,
        }),
        ...mapGetters('areaPersonal/calculadora', {
            currentNameMonthYear: 'currentNameMonthYear',
            nextNameMonthYear: 'nextNameMonthYear',
        }),
    },
    methods: {
        copyObjetivesNextMonth() {
            this.$store.commit(
                'areaPersonal/calculadora/isLoadingCopyObjetives',
                true
            );
            this.$store.dispatch(
                'areaPersonal/calculadora/copyObjetivesNextMonth'
            );
        },
    },
};
</script>
